import { Trans } from 'react-i18next';

import PaymentStore from '@/services/payments/PaymentStore';

export function FinvoiceDetails() {
  switch (PaymentStore.legalEntity) {
    case 510001:
      return <Trans i18nKey={'OfflinePayment_Finvoice_510001_Info'} />;
    default:
      return null;
  }
}
